<script>
import {Line} from 'vue-chartjs'

export default {
  extends: Line,
  props: {
    focusIndex: null,
    assetList: {},
  },
  data: function () {
    return {
    }
  },
  watch: {
    focusIndex: function (val) {
      this.rerender()
    }
  },
  created: function () {
  },
  mounted: function () {
    this.rerender()
  },
  methods: {
    rerender: function () {
        const _this = this
        const chartData = {
          labels: this.assetList.map(asset => {
            return `${asset.assetYear}. ${asset.assetMonth}`
          }),
          datasets: [
            {
              label: '최대 수요전력',
              borderColor: '#2F98E8',
              backgroundColor: 'rgba(47, 152, 232, 0.4)',
              data: this.assetList.map(asset => asset.basicFee)
            },
          ],
        }

        const options = {
          animation: {
            duration: 0
          },
          scales: {
            yAxes: [
              {
                ticks: {
                  callback: function (value) {
                    // return value / 10000 + '만'
                    return value
                  }
                }
              }
            ]
          }
        }

        this.renderChart(chartData, options)
      }
  }
}
</script>
